// src/services/UserService.js

const API = '/api/usuarios';

/**
 * Obtiene la lista completa de usuarios
 */
export const getUsuarios = async () => {
  const response = await fetch(API);
  if (!response.ok) throw new Error('No se pudo cargar la lista de usuarios');
  return await response.json();
};

/**
 * Guarda un usuario nuevo o actualiza uno existente
 */
export const saveUsuario = async (userData) => {
  const response = await fetch(API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(userData),
  });
  
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Error al guardar el usuario');
  return data;
};

/**
 * Elimina un usuario por su ID
 */
export const deleteUsuario = async (id) => {
  // Unificamos la ruta base con el parámetro de ID
  const response = await fetch(`${API}?id=${id}`, {
    method: 'DELETE',
  });
  
  if (!response.ok) throw new Error('No se pudo eliminar el usuario');
  return await response.json();
};